var ValidationMessages = function() {
	var self = this;
	var language = "en";
	var messageRequired = "";
	var messageOptionsEquals = "";
	var messageValidNewPassword = "";
	var messageValidUserName = "";
	var messageNumber = "";

	function init() {
		self.changeMessages();
	}

	// Muda as mensagens de erro para o idioma correto
	this.changeMessages = function() {
		if (localStorage.language) {
			language = localStorage.language;
		}

		switch(language) {
			case 'pt':
				messageRequired = "Campo obrigatório";
				messageOptionsEquals = "Esta frase já foi selecionada";
				messageValidNewPassword = "As senhas não são iguais";
				messageValidUserName = "Os nomes não são iguais";
				messageNumber = "O valor deve ser numérico";

				if ($('[data-component="wire-transfer-request"]').length > 0) {
					var comp = $('[data-component="wire-transfer-request"]');
					comp.find('#value-date').datepicker("destroy");
					comp.find('#value-date').datepicker({
						dateFormat: 'dd/mm/yy',
						dayNames: ['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'],
						dayNamesMin: ['D','S','T','Q','Q','S','S','D'],
						dayNamesShort: ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb','Dom'],
						monthNames: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
						monthNamesShort: ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'],
						nextText: 'Próximo',
						prevText: 'Anterior'
					});
				}
				break;

			case 'es':
				messageRequired = "Campo obligatorio";
				messageOptionsEquals = "Esta frase ya ha sido seleccionada";
				messageValidNewPassword = "Las contraseñas no son iguales";
				messageValidUserName = "Los nombres no son iguales";
				messageNumber = "El valor debe ser numérico";

				if ($('[data-component="wire-transfer-request"]').length > 0) {
					var comp = $('[data-component="wire-transfer-request"]');
					comp.find('#value-date').datepicker("destroy");
					comp.find('#value-date').datepicker({
						dateFormat: 'dd/mm/yy',
						dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
						dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
						dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Juv', 'Vie', 'Sáb'],
						monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
						monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
						nextText: 'Sig>',
						prevText: '<Ant'
					});
				}
				break;

			default:
				messageRequired = "This field is required.";
				messageOptionsEquals = "This sentence has already been selected";
				messageValidNewPassword = "The Passwords are not the same";
				messageValidUserName = "The names are not the same";
				messageNumber = "Value should be numeric";

				if ($('[data-component="wire-transfer-request"]').length > 0) {
					var comp = $('[data-component="wire-transfer-request"]');
					comp.find('#value-date').datepicker("destroy");
					comp.find('#value-date').datepicker();
				}
		}

		jQuery.extend(jQuery.validator.messages, {
			required: messageRequired,
			optionsEquals: messageOptionsEquals,
			validNewPassword: messageValidNewPassword,
			validUserName: messageValidUserName,
			number: messageNumber
		});
	}

	return init();
}

$(document).ready(function(){
	optionsEquals();
	validNewPassword();
	validUserName();
});

function optionsEquals() {
	if ($('[data-component="user-authenticity-questions"]').length > 0) {
		var comp = $('[data-component="user-authenticity-questions"]');
		jQuery.validator.addMethod("optionsEquals", function(value, element) {
			var selects = comp.find('select');
			var size = selects.length;

			for (var i = 0; i < size; i++) {
				if ($(selects[i]).val() == value && selects[i] != element) {
					return false;
				}
			}

			return true;
		}, "This sentence has already been selected");
	}
}

function validNewPassword() {
	if ($('[data-component="password-change"]').length > 0) {
		var comp = $('[data-component="password-change"]');
		jQuery.validator.addMethod("validNewPassword", function(value, element) {
			return comp.find('#new-password').val() == comp.find('#confirm').val();
		}, "The passwords are not the same");
	}
}

function validUserName() {
	if ($('[data-component="customize-login-information"]').length > 0) {
		var comp = $('[data-component="customize-login-information"]');
		jQuery.validator.addMethod("validUserName", function(value, element) {
			return comp.find('#choose-user-name').val() == comp.find('#confirm-user-name').val();
		}, "The User Name are not the same");
	}
}
